import { omrehBaseClient } from "./client";

const CustomCreate = (arr) => {
  return omrehBaseClient.post('GuestGroup/CustomCreate', arr)
}

const GetGroupInfo = () => {
  return omrehBaseClient
    .get("/GuestGroup/GetGroupInfo");
}

const CompletedPassportImageFileForGuestGroup = (guestGroupId) => {
  return omrehBaseClient
    .get("/GuestGroup/CompletedPassportImageFileForGuestGroup", {
      params: {
        'guestGroupId': guestGroupId
      }
    });
}


const FilterGroup = (data) => {
  return omrehBaseClient.post('/GuestGroup/FilterGroup',
    {
      "name": data.name,
      "family": data.family,
      "passNo": data.passNo,
      "startTrip": data.startTrip,
      "endTrip": data.endTrip,
      "paginationParam": {
        "orderBy": data.orderBy,
        "orderDescending": data.orderDescending,
        "pageNumber": data.pageNumber,
        "pageSize": data.pageSize
      }
    }
  );
}

const GetGroupInfoById = (id) => {
  return omrehBaseClient
    .get("/GuestGroup/GetGroupInfoById", {
      params: {
        'Id': id
      }
    });
}

const AddMemberToGroup = (id, data) => {
  return omrehBaseClient.put('/GuestGroup/AddMemberToGroup', {
    "name": data.name,
    "family": data.family,
    "fatherName": data.fatherName,
    "ssn": data.ssn,
    "passNO": data.passNO,
    "mBirthDate": data.mBirthDate,
    "ageCategory": data.ageCategory,
    "emailAddress": data.emailAddress,
    "mobileNO": data.mobileNO,
    "address": data.address,
  }, {
    params: {
      'id': id
    }
  }
  )
}

const Update = (id, data) => {
  return omrehBaseClient.put('/GuestGroup', {
    "startTrip": data.startTrip,
    "endTrip": data.endTrip,
    "description": data.description
  }, {
    params: {
      'id': id
    }
  }
  )
}

const guestGroupApi = {
  CustomCreate, GetGroupInfo, CompletedPassportImageFileForGuestGroup, FilterGroup, GetGroupInfoById, AddMemberToGroup, Update
}

export default guestGroupApi